import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { APIService } from 'src/app/api.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
  selector: 'app-batch-analysis',
  templateUrl: './batch-analysis.component.html',
  styleUrls: ['./batch-analysis.component.scss']
})
export class BatchAnalysisComponent implements OnInit, AfterViewInit {

  agencyData: any = [];
  jarvisData: any = [];
  batchData: any = [];
  batchAnaData: any = [];
  exportToExcel: any = [];
  categories: any = [];
  subCategories: any = [];
  selectedFilter: any = {
    categoryID: 0,
    category: '',
    subCategoryID: 0,
    subCategory:'',
    importanceID: 3,
    importance: '',
    expiryStatus: 0
  }
  search: string = '';
  selectedDate: Date | null = null;
  minDate: Date = new Date(); 

  displayedColumns: string[] = ['ItemName', 'ItemCode', 'BatchName', 'BatchQty', 'SKU', 'EntryDT', 'ExpiryDT'];
  dataSource = new MatTableDataSource();
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
  @ViewChild(MatPaginator) 
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  } 

  constructor(private router: Router, private apiService: APIService) { }

  ngOnInit(): void {
    let jarvis: any = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    
    let agencyData = this.apiService.getCookie('M');
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    this.getData();
  }
  
  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }

  getData() {
    const myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'getBatchAnalysis',
        moduleID: 12,
        data: JSON.stringify([]),
    }];

    this.apiService.getData(myParams, this.batchAnaSuccessResp.bind(this), this.batchAnaFailResp.bind(this));
  }

  batchAnaSuccessResp(res: any) {
    if(res) {
      const batchAnaData = JSON.parse(res.updatePackage);
      if(batchAnaData.Table[0].ErrCode != -1) {
        alert(batchAnaData.Table[0].ErrMsg);
      }
      else {
        this.batchAnaData = batchAnaData.Table1;
        let tmpERP_Cfg = this.apiService.getCookie("ERP_Cfg");
        if(tmpERP_Cfg){
          const tagData =  JSON.parse(tmpERP_Cfg);
          if(tagData){
            this.categories = JSON.parse(tagData[0].ItemCategories);
          }
        }   
        this.batchData = this.batchAnaData.filter((item: any) => item.BatchQty != 0);
        this.dataSource.data = this.batchData;
        this.exportToExcel = this.batchData;
      }
    }
  }

  batchAnaFailResp(res: any) {
    if(!res.error) {
      alert(res.message)
    }
  }

  filterCategory() {
    const category = this.categories.find((category: any) => category.cid == this.selectedFilter.categoryID);
    this.selectedFilter.category = category.cnm;
    if(category?.sub) {
      this.subCategories = category.sub;
      this.selectedFilter.subCategoryID = 0;
      this.selectedFilter.subCategory = 'All Sub-Categories';
    }    
  }

  filterSubCategory() {
    const subCategory = this.subCategories.find((subCategory: any) => subCategory.sid == this.selectedFilter.subCategoryID);
    this.selectedFilter.subCategory = subCategory.snm;
  }

  applyFilter(type?: string) {
    let filteredItems = this.batchData;
  
    if (this.selectedFilter.categoryID != 0) {
      if (type == 'category') {
        this.filterCategory();
      }
      filteredItems = filteredItems.filter((item: any) => item.CategoryID == this.selectedFilter.categoryID);
    } else {
      this.subCategories = [];
      this.selectedFilter.subCategoryID = 0;
      this.selectedFilter.subCategory = 'All Sub-Categories';
    }
  
    if (this.selectedFilter.subCategoryID != 0) {
      this.filterSubCategory();
      filteredItems = filteredItems.filter((item: any) => item.SubCategoryID == this.selectedFilter.subCategoryID);
    }
  
    if (this.selectedFilter.importanceID != 3) {
      filteredItems = filteredItems.filter((item: any) => item.ImportanceID == this.selectedFilter.importanceID);
    }
  
    if (this.selectedFilter.expiryStatus != 0) {
      const now = new Date();
      if (this.selectedFilter.expiryStatus === 1) { // Expired
        this.selectedDate = null;
        filteredItems = filteredItems.filter((item: any) => item.BatchType == 2 && new Date(item.ExpiryDT) < now);
      } else { // Not Expired
        if (this.selectedDate) {
          const selectedDateNormalized = new Date(this.selectedDate).setHours(0, 0, 0, 0); 
  
          filteredItems = filteredItems.filter((item: any) => {
            const expiryDate = new Date(item.ExpiryDT).setHours(0, 0, 0, 0); 
  
            if (
              item.BatchType == 2 && expiryDate >= now.setHours(0, 0, 0, 0) && expiryDate <= selectedDateNormalized ) {
              return true;
            } 
            else {
              return false; 
            }
          });
        } else {
          filteredItems = filteredItems.filter((item: any) => item.BatchType == 1 || (item.BatchType == 2 && new Date(item.ExpiryDT) >= now));
        }
      }
    }
  
    this.exportToExcel = filteredItems;
    this.dataSource.data = filteredItems;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  
  searchFilter(event: Event) {
    let searchString = (event.target as HTMLInputElement).value;
    this.dataSource.filter = searchString.trim().toLowerCase();
  }

  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
      , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

    return function (table: any, name: string, fileName: any) {
      if (!table.nodeType) table = table
      var ctx = { worksheet: name || 'Worksheet', table: table }
      var link = document.createElement("a");
      link.download = fileName || 'download.xls';
      link.href = uri + base64(format(template, ctx));
      link.click();
    }
  })()

  exportToExcelActivities() {
    const reportTitle = "Stock Batches"
    var html = "";
    html += "<table><tr>";
    html += "<th style='text-align: left;'>" + reportTitle + "</th>"
    html += "</table></tr>";
    html += "<table><tr></table></tr>";
    html += "<table><tr></table></tr>";
    html += "<table><tr>";

    var strHeader = ""
    strHeader += "<th style='text-align: left;'>Item</th>";
    strHeader += "<th style='text-align: left;'>Code</th>";
    strHeader += "<th style='text-align: left;'>Batch</th>";
    strHeader += "<th style='text-align: right;'>Qty</th>";
    strHeader += "<th style='text-align: left;'>Unit</th>";
    strHeader += "<th style='text-align: left;'>Entry</th>";
    strHeader += "<th style='text-align: left;'>Expiry</th>";
    strHeader += "</tr>"
    html += strHeader;

    var body = "";
    this.exportToExcel.forEach((item:any, key:any) => {
      body += "<tr>";
      body += "<td style='text-align: left;'>" + item.ItemName + "</td>";
      body += "<td style='text-align: left;'>" + item.ItemCode + "</td>";
      body += "<td style='text-align: left;'>" + item.BatchName + "</td>";
      body += "<td style='text-align: right;'>" + item.BatchQty + "</td>";
      body += "<td style='text-align: left;'>" + item.SKU + "</td>";
      body += "<td style='text-align: left;'>" + this.formatDate(item.EntryDT) + "</td>";
      body += "<td style='text-align: left;'>" + (item.BatchType == 2 ? this.formatDate(item.ExpiryDT) : '-') + "</td>";
      body += "</tr>";
    })

    html += body;
    html += "</table>";
    this.tableToExcel(html, 'Sheet1', reportTitle);
  }

  backBtn() {
    this.router.navigate(['/Stock']);
  }

  refresh() {
    window.location.reload();
  }

  formatDate(date: string) {
    const d = new Date(date);
    const day = ('0' + d.getDate()).slice(-2);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }
  
  onDateChange(event: any) {
    this.selectedDate = event;
    this.applyFilter('expiry');
  }
}
